import React, { Component } from "react";
import { connect } from "react-redux";
import { callApi } from "../utils";
import { showError } from "../actions/notificationActions";
import FaqQuestion from "./FaqQuestion";

export default connect((state) => ({}))(
  class FAQ extends Component {
    state = {
      faq: [],
    };

    retrieveFaq() {
      callApi("/faq")
        .then(({ data }) => this.setState({ faq: data }))
        .catch((err) => this.props.dispatch(showError(err)));
    }

    componentDidMount() {
      this.retrieveFaq();
    }

    render() {
      const { faq } = this.state;
      return (
        <div>
          {this.props.location.search.indexOf("bp-no-header=true") === -1 && (
            <div>
              <div className="banner bg-img">
                <div className="contain" />
              </div>
            </div>
          )}
          <div className="contain">
            <div className="faq">
              <h3 style={{ textAlign: "center" }}>
                Frequently Asked Questions
              </h3>
              <hr />
              {faq.map((f, key) => (
                <div key={key}>
                  <h4>{f.category}</h4>
                  <ol>
                    {f.faq.map((qa) => (
                      <FaqQuestion key={qa.id} faq={qa} />
                    ))}
                  </ol>
                </div>
              ))}
            </div>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/Faq.js